
export const setPoints = (state, points) => {
    state.points = points
    state.loading = false
}

export const setCurrentPoint = (state, point) => {
    state.currentPoint = point
    state.loading = false
}

export const setLoading = (state, loading) => {
    state.loading = loading
}
